module.exports = __webpack_public_path__ + "static/media/photo3.81d646e9.png";